<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<h1 mat-dialog-title class="dialog-title">{{ title }}</h1>
<button
	class="dialog-close-btn"
	mat-icon-button
	*ngIf="showIconButton"
	[mat-dialog-close]="isCloseButton"
	automationId="closeButton"
>
	<mat-icon>{{ icon }}</mat-icon>
</button>
